// Store Imports
import { signalStore, withState } from '@ngrx/signals'
// Shared Imports

export interface EnvironmentState {
	version: string
}

const initialState: EnvironmentState = {
	version: '3.0.0',
}

export const EnvironmentStore = signalStore({ providedIn: 'root' }, withState(initialState))
